import React, { Fragment } from 'react'
import { bool } from 'prop-types'
import { createComponent, withTheme } from '@ycos/fela'
import { createFontStyle, HeadingMedium } from '@ycos/primitives'

const ServiceMessage = createComponent('div', () => {
  return {
    width: '100%',
    textAlign: 'center',
  }
})

const BlockTitle = createFontStyle(
  'BlockTitle',
  {
    type: 'Paragraph',
    tagName: 'h3',
    name: '5',
  },
  ({ theme }) => ({
    width: '100%',
    color: theme.typography.colors.PrimaryBlack,
    marginBottom: 0,
    fontWeight: 'bold',
  })
)

const BlockTitleLarge = createComponent(
  'BlockTitleLarge',
  ({ theme }) => ({
    marginBottom: `${theme.spacingMultiplier * 3}px`,
  }),
  HeadingMedium
)

const getBlockText = (layoutVariant, customTextTheme) => {
  const useCustomFont = layoutVariant === 'isc-service-message-block-large-title' && customTextTheme
  return createFontStyle(
    'BlockText',
    {
      ...(useCustomFont ? { type: customTextTheme.type, name: customTextTheme.name } : { type: 'Label', name: '4' }),
      tagName: 'p',
    },
    ({ theme, isCarouselItem }) => ({
      width: '100%',
      color: customTextTheme?.color || theme.typography.colors.SecondaryGreyMetal,
      marginBottom: isCarouselItem ? `${3 * theme.spacingMultiplier}px` : `${4 * theme.spacingMultiplier}px`,
      marginTop: `${theme.spacingMultiplier}px`,
      'screen-large': {
        marginBottom: 0,
      },
    })
  )
}

const Image = createComponent(
  'Image',
  () => ({
    width: '24px',
    height: '24px',
    margin: '0 auto -3px',
  }),
  'img'
)

const getImageCounter = ({ type, name }) =>
  createFontStyle(
    'ImageCounter',
    {
      type,
      tagName: 'span',
      name,
    },
    ({ theme }) => ({
      width: '45px',
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: `0 auto ${theme.spacingMultiplier * 3}px`,
      border: `1px solid ${theme.typography.colors.PrimaryBlack}`,
      borderRadius: '50%',
      color: theme.typography.colors.PrimaryBlack,
    })
  )

const getExtension = (imageUrl) => {
  const extensionRegex = /\.(\w{3,4})(?:$|\?)/i
  const extensionMatch = imageUrl.match(extensionRegex)

  return extensionMatch && extensionMatch[1] && extensionMatch[1].toLowerCase()
}

const AnchorWrapper = ({ children, href, onTargetClick }) => (
  <a href={href} onClick={onTargetClick} data-automation="service-block-anchor-link">
    {children}
  </a>
)

const ServiceMessageBlock = ({ item, isCarouselItem, onTargetClick, index, theme }) => {
  const { teaserTitle, teaserText, pictures = [], dataCmMetadata, target = {}, layoutVariant, fetchPriority } = item
  const url = pictures[0]?.imageUrl || ''
  const imageUrl = url.indexOf('www.net-a-porter.com/content/images') > -1 ? `${url}/w0.${getExtension(url)}` : url
  const TitleComponent = layoutVariant === 'isc-service-message-block-large-title' ? BlockTitleLarge : BlockTitle
  const blockCustomTheme = theme.custom.serviceMessageBlock
  const ImageCounter = getImageCounter({ type: blockCustomTheme?.counter?.type, name: blockCustomTheme?.counter?.name })
  const BlockText = getBlockText(layoutVariant, blockCustomTheme?.text)
  const Wrapper = !target.href ? Fragment : AnchorWrapper
  const showPicture = pictures && pictures[0]

  return (
    <Wrapper href={target.href} onClick={onTargetClick}>
      <ServiceMessage data-cm-metadata={dataCmMetadata}>
        {showPicture ? <Image fetchPriority={fetchPriority} src={imageUrl} /> : <ImageCounter>{index + 1}</ImageCounter>}

        <TitleComponent>{teaserTitle}</TitleComponent>
        <BlockText data-automation="service-block-text" isCarouselItem={isCarouselItem}>
          {teaserText}
        </BlockText>
      </ServiceMessage>
    </Wrapper>
  )
}

ServiceMessageBlock.layoutVariant = ['nap-homepage-service-message-block', 'isc-service-message-block', 'isc-service-message-block-large-title']

ServiceMessageBlock.propTypes = {
  isCarouselItem: bool,
}

ServiceMessageBlock.defaultProps = {
  isCarouselItem: false,
}

export default withTheme(ServiceMessageBlock)
